import { Modal } from "react-bootstrap";
import Collapsible from 'react-collapsible';
import React from "react";
import "../modal.css";
import "react-datepicker/dist/react-datepicker.css";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { PROVIDER_POSITIONS } from "../enum";

const basicSchema = Yup.object().shape({
    typeName: Yup.string().required("Type Name is required"),
    pricePerKM: Yup.number().required("Price Per KM is required"),
    surgePricePerKM: Yup.number().required("Price Per KM is required"),
    noOfSeats: Yup.number().required("No Of Seats Per KM is required"),
    status: Yup.string().required("Status is required"),
    provider_type: Yup.number().required("Provider Type is required"),
    file: Yup.mixed().required("Image is required"),
});

const Edit = ({ showModal, hideModal, id, data, getVehicleTypes }) => {
    const history = useNavigate();
    const onSubmit = async (values, actions) => {
        await new Promise((resolve) => setTimeout(resolve, 1000));
        editVehicleType(values);
    };

    const { values,
        errors,
        touched,
        isSubmitting,
        setFieldValue,
        handleBlur,
        handleChange,
        handleSubmit, submitForm } = useFormik({

            initialValues: {


                typeName: data.typeName,
                pricePerKM: data.pricePerKM,
                surgePricePerKM: data.surgePricePerKM,
                noOfSeats: data.noOfSeats,
                status: data.status,
                file: data.image,
                provider_type: data.provider_type || PROVIDER_POSITIONS.RIDE_PROVIDER,
                pricePerMinute: data.pricePerMinute || '',
                surgePricePerMinute: data.surgePricePerMinute || '',
                pricingMode: data.pricingMode || 'distance',
                minimumTreatmentTime: data.minimumTreatmentTime || 0,
                initialPrice: data.initialPrice || 0,
                minimumDistance: data.minimumDistance || 0,
                maximumDistance: data.maximumDistance || 0,
                outOfCityPricePerKM: data.outOfCityPricePerKM || 0,
                outOfCitySurgePricePerKM: data.outOfCitySurgePricePerKM || 0,

            },
            validationSchema: basicSchema,
            onSubmit
        })


    const notifySuccess = () => toast.info('Driver info Updated.', {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
    });

    const notifyError = () => toast.error('Something went wrong ...', {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
    });

    const editVehicleType = async (e, i) => {

        try {

            const bodyFormData = new FormData();
            for (let value in values) {
                bodyFormData.append(value, values[value]);
                bodyFormData.append("id", id);
            }


            const response = await axios.post("/vehicleType/" + id, bodyFormData);
            history("/vehicleTypes");
            hideModal();
            getVehicleTypes();
            notifySuccess();

            console.log(response.status)
        } catch (error) {
            console.log(error.response)
            if (error.response) {
                notifyError();
            }
        }
    };


    return (


        <form onSubmit={handleSubmit} autoComplete="off" encType="multipart/form-data">


            <Modal
             style={{marginTop: "60px"}} 
                show={showModal}
                onHide={hideModal}
                backdrop={false}
                aria-labelledby="contained-modal-title-vcenter"
            >

                <Modal.Header closeButton>
                    <Modal.Title>Edit VehicleType</Modal.Title>
                </Modal.Header>
                <Modal.Body

                >

                    <div class="row" >
                        <div class="col-md-12">
                            <div class="card card-primary">


                                <div class="card-body">
                                    <div class="form-group">
                                        <label for="inputName">Type Name</label>
                                        <input
                                            type="text"
                                            name="typeName"
                                            value={values.typeName}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            className={errors.typeName && touched.typeName ? "form-control input-error" : "form-control "}

                                        />
                                        {errors.typeName && touched.typeName && <p className="error">{errors.typeName}</p>}

                                    </div>

                                    <div class="form-group">
                                        <label for="inputName">Price Per KM</label>
                                        <input
                                            type="number"
                                            name="pricePerKM"
                                            value={values.pricePerKM}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            className={errors.pricePerKM && touched.pricePerKM ? "form-control input-error" : "form-control "}

                                        />
                                        {errors.pricePerKM && touched.pricePerKM && <p className="error">{errors.pricePerKM}</p>}

                                    </div>

                                    <div class="form-group">
                                        <label for="inputName">Surge Price Per KM</label>
                                        <input
                                            type="number"
                                            name="surgePricePerKM"
                                            value={values.surgePricePerKM}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            className={errors.surgePricePerKM && touched.surgePricePerKM ? "form-control input-error" : "form-control "}

                                        />
                                        {errors.surgePricePerKM && touched.surgePricePerKM && <p className="error">{errors.surgePricePerKM}</p>}

                                    </div>

                                    <div class="form-group">
                                        <label for="inputName">Out-of-City Price Per KM</label>
                                        <input
                                            type="number"
                                            step="0.01"
                                            name="outOfCityPricePerKM"
                                            value={values.outOfCityPricePerKM}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            className="form-control"
                                            placeholder="Price per KM from Addis to other cities (e.g., Bahir Dar, Hawassa)"
                                        />
                                    </div>

                                    <div class="form-group">
                                        <label for="inputName">Out-of-City Surge Price Per KM</label>
                                        <input
                                            type="number"
                                            step="0.01"
                                            name="outOfCitySurgePricePerKM"
                                            value={values.outOfCitySurgePricePerKM}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            className="form-control"
                                            placeholder="Surge price per KM from Addis to other cities during peak hours"
                                        />
                                    </div>

                                    <div class="form-group">
                                        <label for="inputName">No Of Seats</label>
                                        <input
                                            type="number"
                                            name="noOfSeats"
                                            value={values.noOfSeats}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            className={errors.noOfSeats && touched.noOfSeats ? "form-control input-error" : "form-control "}

                                        />
                                        {errors.noOfSeats && touched.noOfSeats && <p className="error">{errors.noOfSeats}</p>}

                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="provider_type">Provider Type</label>
                                        <select
                                            id="provider_type"
                                            name="provider_type"
                                            className={
                                                errors.provider_type && touched.provider_type
                                                    ? "form-control input-error"
                                                    : "form-control"
                                            }
                                            value={values.provider_type}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        >
                                            <option value="">Select Provider Type</option>
                                            <option value={PROVIDER_POSITIONS.FIRST_RESPONDER}>First Responder</option>
                                            <option value={PROVIDER_POSITIONS.AMBULANCE_PROVIDER}>Ambulance Provider</option>
                                            <option value={PROVIDER_POSITIONS.RIDE_PROVIDER}>Ride Provider</option>
                                            <option value={PROVIDER_POSITIONS.HOMECARE_PROVIDER}>HomeCare Provider</option>
                                        </select>
                                        {errors.provider_type && touched.provider_type && (
                                            <p className="error">{errors.provider_type}</p>
                                        )}
                                    </div>

                                    {/* Time-based Pricing Fields */}
                                    <div class="form-group">
                                        <label for="inputName">Price Per Minute</label>
                                        <input
                                            type="number"
                                            step="0.01"
                                            name="pricePerMinute"
                                            value={values.pricePerMinute}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            className="form-control"
                                            placeholder="Enter price per minute for treatment"
                                        />
                                    </div>

                                    <div class="form-group">
                                        <label for="inputName">Surge Price Per Minute</label>
                                        <input
                                            type="number"
                                            step="0.01"
                                            name="surgePricePerMinute"
                                            value={values.surgePricePerMinute}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            className="form-control"
                                            placeholder="Enter surge price per minute"
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="pricingMode">Pricing Mode</label>
                                        <select
                                            id="pricingMode"
                                            name="pricingMode"
                                            className="form-control"
                                            value={values.pricingMode}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        >
                                            <option value="distance">Distance-based (Per KM)</option>
                                            <option value="time">Time-based (Per Minute)</option>
                                            <option value="both">Both Distance + Time</option>
                                        </select>
                                    </div>

                                    <div class="form-group">
                                        <label for="inputName">Minimum Treatment Time (Minutes)</label>
                                        <input
                                            type="number"
                                            name="minimumTreatmentTime"
                                            value={values.minimumTreatmentTime}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            className="form-control"
                                            placeholder="Minimum billable treatment time"
                                        />
                                    </div>

                                    <div class="form-group">
                                        <label for="inputName">Initial Price</label>
                                        <input
                                            type="number"
                                            name="initialPrice"
                                            value={values.initialPrice}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            className="form-control"
                                            placeholder="Initial price for the service"
                                        />
                                    </div>

                                    <div class="form-group">
                                        <label for="inputName">Minimum Distance (KM)</label>
                                        <input
                                            type="number"
                                            step="0.01"
                                            name="minimumDistance"
                                            value={values.minimumDistance}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            className="form-control"
                                            placeholder="Minimum billable distance in kilometers"
                                        />
                                    </div>

                                    <div class="form-group">
                                        <label for="inputName">Maximum Distance (KM)</label>
                                        <input
                                            type="number"
                                            step="0.01"
                                            name="maximumDistance"
                                            value={values.maximumDistance}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            className="form-control"
                                            placeholder="Maximum distance in kilometers"
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label for="inputStatus">Status</label>
                                        <select
                                            id="inputStatus"
                                            class="form-control custom-select"
                                            name="status"
                                            value={values.status}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            className={errors.status && touched.status ? "form-control input-error" : "form-control "}

                                        >
                                            <option selected>
                                                Select Status
                                            </option>

                                            <option key={"Active"} value={"Active"}>
                                                {"Active"}
                                            </option>
                                            <option key={"Inactive"} value={"Inactive"}>
                                                {"Inactive"}
                                            </option>

                                        </select>
                                        {errors.status && touched.status && <p className="error">{errors.status}</p>}

                                    </div>
                                    <div class="form-group">
                                        <label for="exampleInputFile"> Image</label>
                                        <Collapsible trigger={<i className="fas fa-eye success"> View</i>}>
                                            <img
                                                className=" img-fluid "
                                                src={
                                                    process.env.REACT_APP_BASE_URL + "/uploads/" +
                                                    values.file
                                                }
                                                height="300px"
                                                width="300px"
                                                alt="vehicle type picture"
                                            />
                                        </Collapsible>
                                        <div class="input-group">
                                            <div class="custom-file">
                                                <input
                                                    type="file"
                                                    class="custom-file-input"
                                                    id="exampleInputFile"
                                                    name="file"
                                                    accept='image/*'

                                                    onChange={(e) =>
                                                        setFieldValue('file', e.currentTarget.files[0])
                                                    }
                                                    className={errors.file && touched.file ? "form-control input-error" : "form-control "}
                                                />

                                            </div>
                                        </div>
                                        {errors.vehicleImage && touched.vehicleImage && <p className="error">{errors.vehicleImage}</p>}
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-error" onClick={hideModal}>
                        Cancel
                    </button>

                    <button disabled={isSubmitting} onClick={submitForm} className="btn btn-success" type="submit">
                        Update
                    </button>

                </Modal.Footer>

            </Modal>
        </form>

    );
};

export default Edit;
